export default __webpack_public_path__ + "static/media/vire.0eaf4ea5.jpg";